import { AutocompleteOption, LocationAutocomplete } from '@checkit/react-components';
import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import {
  CheckpointTypeAutocomplete,
  SingularProps
} from '../../../../components/checkpointTypeAutocomplete/CheckpointTypeAutocomplete';

export interface InitialValues {
  location: AutocompleteOption | undefined;
  type: AutocompleteOption | undefined;
}

export interface Props {
  onLocationChange: SingularProps['onChange'];
  initialValues: InitialValues;
  onTypeChange: SingularProps['onChange'];
}

const messages = defineMessages({
  'checkpoints.search.filterByLocation': {
    defaultMessage: 'Filtered By Location',
    id: 'checkpoints.search.filterByLocation'
  },
  'checkpoints.search.filterByType': {
    defaultMessage: 'and Checkpoint Type',
    id: 'checkpoints.search.filterByType'
  },
  'checkpoints.search.locationPlaceholder': {
    defaultMessage: 'Unassigned',
    id: 'checkpoints.search.locationPlaceholder'
  },
  'checkpoints.search.typePlaceholder': {
    defaultMessage: 'Any',
    id: 'checkpoints.search.typePlaceholder'
  }
});

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2)
    },
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-end',
      display: 'flex',
      flexDirection: 'row'
    }
  },
  searchFilter: {
    [theme.breakpoints.up('sm')]: {
      flexGrow: 2,
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2)
    }
  },
  searchFilterInput: {
    textAlign: 'center'
  },
  textSpan: {
    marginRight: theme.spacing(1)
  }
}));

const SearchFilters = (props: Props) => {
  const {onLocationChange, onTypeChange, initialValues} = props;

  const initialLocation = initialValues.location;
  const initialType = initialValues.type;

  const classes = useStyles();
  const {formatMessage} = useIntl();

  return (
    <div className={classes.container} >
      <span className={classes.textSpan}>{formatMessage(messages['checkpoints.search.filterByLocation'])}</span>
      <div className={classes.searchFilter} data-testid="location-filter">
        <LocationAutocomplete
          label={''}
          placeholder={formatMessage(messages['checkpoints.search.locationPlaceholder'])}
          onChange={onLocationChange}
          initialValue={initialLocation}
          className={classes.searchFilterInput}
        />
      </div>
      <span className={classes.textSpan}>{formatMessage(messages['checkpoints.search.filterByType'])}</span>
      <div className={classes.searchFilter} data-testid="type-filter">
        <CheckpointTypeAutocomplete
          multiple={false}
          label={''}
          placeholder={formatMessage(messages['checkpoints.search.typePlaceholder'])}
          onChange={onTypeChange}
          initialValue={initialType}
          className={classes.searchFilterInput}
        />
      </div>
    </div>
  );
};

export default SearchFilters;
